// extracted by mini-css-extract-plugin
module.exports = {"path":"FileBrowserError_path__cBaRO"};